export const environment = {
  production: true,
  dbConfig: {
    apiKey: "AIzaSyB79S-w_sAcrtARDcPOGedugIcVSePqapQ",
    authDomain: "recog-prod.firebaseapp.com",
    databaseURL: "https://recog-prod.firebaseio.com",
    projectId: "recog-prod",
    storageBucket: "recog-prod.appspot.com",
    messagingSenderId: "27378137749"
  }
};



// WEBPACK FOOTER //
// C:/Users/Alec/Documents/dev/recog/recog/src/environments/environment.ts